/* unplugin-vue-components disabled */import script from "./search-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./search-dialog.vue?vue&type=style&index=0&id=63df9b59&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63df9b59"]])

export default __exports__